import { http, getApiUrl } from './request.js'

// 应收详单列表
const queryReceivableList = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/receivable/list'), payload);
}

// 应收账单列表
const queryBillingReportList = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/billing-report/list'), payload);
}

// 账单详情
const queryBillingReportDetail = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/billing-report/detail'), payload);
}

// 登记发票信息
const updateInvoiceRecord = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/billing-report/update-invoiceRecord'), payload);
}

// 清空发票登记记录
const clearInvoiceRecord = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/billing-report/clear-invoiceRecord'), payload);
}

export {
    queryReceivableList,
    queryBillingReportList,
    queryBillingReportDetail,
    updateInvoiceRecord,
    clearInvoiceRecord
}